module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "alert-list"
  }, [_c('transition-group', {
    attrs: {
      "name": "alerts",
      "enter-active-class": "animated fadeIn",
      "leave-active-class": "animated bounceOutRight",
      "tag": "div"
    }
  }, _vm._l((_vm.alerts), function(alert, index) {
    return _c('div', {
      key: index
    }, [_c('alert', {
      attrs: {
        "title": alert.title,
        "message": alert.message,
        "type": alert.type
      },
      on: {
        "close": function($event) {
          _vm.remove(index)
        }
      }
    })], 1)
  }))], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a831b08","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Notification.vue
// module id = 825
// module chunks = 1